import { bodiesOverlap } from '../geom'
import { NO_PLAYER } from '../world'
import { moveFallingBody } from './body'
import { hit } from './hit'
import type { ProjectileItem } from './types'

/**
 * Spike Ball: rolls right from the owner's front edge at ground level with gravity and the
 * players' terrain collision. The first non-owner it overlaps who can be hit is stunned and the
 * ball is gone; a wall, a fall past `killY` or `lifetimeTicks` also end it. Jumping clears it.
 */
export const spikeBall: ProjectileItem = {
  id: 'spike_ball',
  use(world, i) {
    const p = world.players[i]!
    const sb = world.cfg.items.spikeBall
    world.projectiles.push({
      id: world.nextId++,
      kind: 'spike_ball',
      owner: i,
      x: p.x + p.w,
      y: p.y,
      w: sb.sizePx,
      h: sb.sizePx,
      vx: sb.speedPxPerTick,
      vy: 0,
      grounded: p.grounded,
      target: NO_PLAYER,
      locked: false,
      expiresAtTick: world.tick + sb.lifetimeTicks,
    })
  },
  update(world, pr, events) {
    if (world.tick >= pr.expiresAtTick) return false
    if (!moveFallingBody(world, pr, pr.vx)) return false
    if (pr.y > world.track.killY) return false
    const { stunTicks } = world.cfg.items.spikeBall
    for (let i = 0; i < world.players.length; i++) {
      if (i === pr.owner || !bodiesOverlap(world.players[i]!, pr)) continue
      if (hit(world, i, 'spike_ball', stunTicks, events, pr.owner)) return false
    }
    return true
  },
}
